import React from "react";
import "../all css/aboutdwecsection.css";
const dwec_logo = require("../../assets/dwec_logo.png");
const badge_img = require("../../assets/aboutexplore/badge.png");
const yellow_line = require("../../assets/aboutexplore/red_line.svg");

function AbouUsSection(props) {
  return (
    <section className="about_dwec_section_main_container">
      <div className="dwec_yellow_container">
        <img src={yellow_line.default} alt="yellow" />
      </div>
      <div className="about_dwec_under_container">
        <div className="dwec_about_us_four_box_container">
          <div className="dwec_two_about_us_container">
            <div className="first_dwec_container">
              <div
                className="about_text_img_contianer wow bounceInLeft"
                data-wow-duration="2s"
                data-wow-delay="0.5"
              >
                <div className="rectangle_container" />
                <p className="about_us_text_dwec">
                  ABOUT <br />
                   DWEC
                </p>
              </div>

              <div
                className="about_content_one_contianer wow bounceInRight"
                data-wow-duration="2s"
                data-wow-delay="0.5s"
              >
                <img className="badge_img" alt="badge" src={badge_img} />

                <p className="about_us_extra_content_text">
                  We provide end-to-end services to students wishing to Study
                  Abroad. We work as a{" "}
                  <span className="highlight_about_us_content">
                    Single-window platform{" "}
                  </span>{" "}
                  for students seeking access to world-class higher education
                  from over 20+ countries. We take it up a notch by handling
                  student’s right from counseling to profile evaluation,
                  shortlisting, application, admission, visas, loans, and job
                  assistance.
                </p>
              </div>
            </div>

            <div className="sec_dwec_container">
              <div
                className="about_content_one_contianer1 wow bounceInRight"
                data-wow-duration="2s"
                data-wow-delay="0.5s"
              >
                <img className="badge_img" alt="badge" src={badge_img} />

                <p className="about_us_extra_content_text">
                  We offer tailor-made solutions for global students to get
                  admission into{" "}
                  <span className="highlight_about_us_content">
                    Ivy League, Oxford, and other top global universities
                  </span>{" "}
                  in UK, USA, Canada and Australia.
                </p>
              </div>
              <div
                className="about_content_one_contianer2 wow bounceInLeft"
                data-wow-duration="2s"
                data-wow-delay="0.5s"
              >
                <img className="badge_img" alt="badge" src={badge_img} />

                <p className="about_us_extra_content_text">
                  Trust our expert advice about meeting unseen, unspoken needs.
                  We will always work closely and set our eyes on what is
                  working well for you and where we need to strengthen our
                  efforts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AbouUsSection;
